astral-nav-rail {
 display: block;
  width: 200px;
}
